import labelBaseTpl from './base';

const labelLinkTpl = `Link`

export { labelLinkTpl }